import { render, staticRenderFns } from "./DashboardLaserscanOffset.vue?vue&type=template&id=fa095828&scoped=true&"
import script from "./DashboardLaserscanOffset.vue?vue&type=script&lang=ts&"
export * from "./DashboardLaserscanOffset.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardLaserscanOffset.vue?vue&type=style&index=0&id=fa095828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa095828",
  null
  
)

export default component.exports